import React from 'react'
import moment from 'moment'

import './cell.component.scss'

const EMPTY_PLACEHOLDER = '-'

/**
 * Updated Date Custom Cell Component
 * @param date
 * @returns {*}
 */
const UpdatedDateCell = ({ date }) => {
  return <div className='cell'>{date ? moment.utc(date).format('MM/DD/YYYY') : EMPTY_PLACEHOLDER}</div>
}

/**
 * Text Custom Cell Component
 * @param data
 * @param type
 * @returns {*}
 */
const TextCell = ({ data, type }) => {
  return <div className={`cell cell--${type}`}>{data || EMPTY_PLACEHOLDER}</div>
}

/**
 * Custom Cell Render
 * @param data
 * @param column
 * @returns {*}
 */
const CustomCell = ({ data = {}, column = {} }) => {
  const cellData = data[column.colId]

  switch (column.colId) {
    case 'author':
      return <TextCell data={cellData} type='text' />
    case 'notes':
      return <TextCell data={cellData} type='paragraph' />
    case 'update_date':
      return <UpdatedDateCell date={cellData} />

    default:
      return EMPTY_PLACEHOLDER
  }
}

export default CustomCell
